import { useAtom } from "jotai";

import { pinnedInsuredsAtom } from "../atoms";
import { cn } from "../utils";
import { Button, type ButtonProps } from "./button";
import { Icon, type MaterialSymbol } from "./icon";

// Pins live in this browser only, keyed by insured id.
export const useInsuredPin = (id: string) => {
  const [pinnedIds, setPinnedIds] = useAtom(pinnedInsuredsAtom);
  const pinned = id in pinnedIds;

  const togglePin = () => {
    if (pinned) {
      const { [id]: _removed, ...rest } = pinnedIds;
      void setPinnedIds(rest);
    } else {
      void setPinnedIds({ [id]: id, ...pinnedIds });
    }
  };

  return { pinned, togglePin };
};

export const InsuredPin = ({
  id,
  className,
  icon = "keep",
  ...props
}: ButtonProps & {
  id: string;
  icon?: MaterialSymbol;
}) => {
  const { pinned, togglePin } = useInsuredPin(id);

  return (
    <Button
      variant="ghost"
      size="xs"
      display="icon"
      className={cn(
        "bg-transparent! transition-colors",
        pinned ? "filled pinned text-primary!" : "text-primary/50!",
        className
      )}
      onClick={(e) => {
        e.stopPropagation();
        togglePin();
      }}
      {...props}
      data-pinned={pinned}
    >
      <Icon
        icon={icon}
        className="transition-transform duration-500 ease-bounce"
        style={{
          transform: `rotate(${pinned ? "385" : "0"}deg)`,
        }}
      />
    </Button>
  );
};
